"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Yup = require("yup");
exports.default = Yup.object().shape({
    original_amount: Yup.string()
        .required('Required')
        .matches(/^\d+\.\d{2}$/, 'The amount must be a number and include exactly 2 decimal places for pence (e.g. 25.00, 25.05, 25.50)')
        .test('min-value', 'Minimum value is £25', function (value) {
        if (value == null)
            return false;
        var num = Number(value);
        return !isNaN(num) && num >= 25;
    })
        .test('max-value', 'Maximum value is £20,000', function (value) {
        if (value == null)
            return false;
        var num = Number(value);
        return !isNaN(num) && num <= 20000;
    }),
    invoice_reference: Yup.string()
        .trim()
        .max(20, 'Invoice reference must be 20 characters or less')
        .required('Required'),
    invoice_due_date: Yup.date().nullable().typeError('Please enter a valid date').required('Required'),
    invoice_sent_date: Yup.date().nullable().typeError('Please enter a valid date').required('Required'),
    reminder_sent_date: Yup.date().nullable().typeError('Please enter a valid date'),
    protocol_id: Yup.number().required('Required'),
    merge_variables: Yup.object({
        representative_name: Yup.string().when('$protocol_id', {
            is: 2,
            then: Yup.string().required('Representative Name is a required field'),
            otherwise: Yup.string().notRequired(),
        }),
    }),
    interest_rate: Yup.string()
        .trim()
        .matches(/^\d+(\.\d{1,6})?$/, 'Enter a valid percentage (up to 6 decimal places)')
        .test('minValue', 'Interest rate must be 0 or higher', function (value) { return !value || parseFloat(value) >= 0; })
        .test('maxValue', 'The interest rate can be a maximum of 8000%', function (value) { return !value || parseFloat(value) <= 8000; }),
    purchase_order_number: Yup.string().trim().max(20, 'Purchase order number must be 20 characters or less'),
    goods_description: Yup.string()
        .nullable()
        .trim()
        .max(250, 'Goods description must be 250 characters or less')
        .test('goods or services', 'If a description of services is not given, then a description of goods provided to the debtor is required', function (value) {
        var services_description = this.parent.services_description;
        if (!services_description) {
            return value != null;
        }
        return true;
    }),
    services_description: Yup.string()
        .nullable()
        .trim()
        .max(250, 'Services description must be 250 characters or less')
        .test('goods or services', 'If a description of goods is not given, then a description of services provided to the debtor is required', function (value) {
        var goods_description = this.parent.goods_description;
        if (!goods_description) {
            return value != null;
        }
        return true;
    }),
});
